import React from 'react';
import { View, Dimensions } from 'react-native';

import { map as _map, get as _get } from 'lodash';
import PropTypes from 'prop-types';

import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import {
  today,
  isExpiredDate,
  AddonsTypes,
  getDateBarNumber,
  getApproximatelyDateBarNumber,
  getAddonExpirationDate,
} from '../helpers';

import TimelineAddOnCard from './TimelineAddOnCard';
import styles from './TimelineAddOnsList.Styles';

function TimelineAddOnsList({ images, data, isMonthView, slot, dates, onItemPress }) {
  const isExpiredAddon = expirationDate => {
    if (isMonthView) {
      return (
        getApproximatelyDateBarNumber(dates, {
          date: today,
        }) >
        getApproximatelyDateBarNumber(dates, {
          date: expirationDate,
        })
      );
    }
    return (
      getDateBarNumber(dates, {
        date: today,
      }) >
      getDateBarNumber(dates, {
        date: expirationDate,
      })
    );
  };

  const addOnsList = data.map((addOn, index) => {
    const addOnHeight = slot;
    const _calculateHeight = index * addOnHeight;
    const _space = index;

    const barShift = 20.5;
    const top = 180 + _calculateHeight + _space;
    const height = 0.6 * (slot + 12);

    const renewableExpirationDateDate = getAddonExpirationDate(
      addOn.duration,
      addOn.expirationDate,
    );

    const widthMonthView =
      (getApproximatelyDateBarNumber(dates, {
        date: addOn.expirationDate,
      }) -
        getApproximatelyDateBarNumber(dates, {
          date: addOn.startingDate,
        })) *
      slot;
    const widthDayView =
      (getDateBarNumber(dates, {
        date: addOn.expirationDate,
      }) -
        getDateBarNumber(dates, {
          date: addOn.startingDate,
        })) *
      slot;
    const widthRenewableMonthView =
      (getApproximatelyDateBarNumber(dates, {
        date: renewableExpirationDateDate,
      }) -
        getApproximatelyDateBarNumber(dates, {
          date: addOn.expirationDate,
        })) *
      slot;
    const widthRenewableDayView =
      (getDateBarNumber(dates, {
        date: renewableExpirationDateDate,
      }) -
        getDateBarNumber(dates, {
          date: addOn.expirationDate,
        })) *
      slot;
    const width = isMonthView ? widthMonthView : widthDayView;
    const widthRenewable = isMonthView ? widthRenewableMonthView : widthRenewableDayView;

    const positionLeft =
      getApproximatelyDateBarNumber(dates, {
        date: addOn.startingDate,
      }) *
      slot +
      barShift;
    const positionLeftDayView =
      getDateBarNumber(dates, {
        date: addOn.startingDate,
      }) *
      slot +
      barShift;

    const addOnHistory = _map(_get(addOn, 'history'), (h, i) => {
      const widthHistoryMonthView =
        (getApproximatelyDateBarNumber(dates, {
          date: h.expirationDate,
        }) -
          getApproximatelyDateBarNumber(dates, {
            date: h.startingDate,
          })) *
        slot;
      const widthHistoryDayView =
        (getDateBarNumber(dates, {
          date: h.expirationDate,
        }) -
          getDateBarNumber(dates, {
            date: h.startingDate,
          })) *
        slot;

      const widthHistory = isMonthView ? widthHistoryMonthView : widthHistoryDayView;

      const historyPositionLeft =
        getApproximatelyDateBarNumber(dates, {
          date: h.startingDate,
        }) *
        slot +
        barShift;
      return (
        <TimelineAddOnCard
          onItemPress={onItemPress}
          key={i}
          slot={slot}
          images={images}
          fullWidth={widthHistory > 1 * slot}
          type={AddonsTypes.EXPIRED}
          addOn={addOn}
          width={widthHistory}
          height={height}
          left={historyPositionLeft}
          top={top}
        />
      );
    });
    return (
      <View key={index}>
        {addOnHistory}
        <TimelineAddOnCard
          onItemPress={onItemPress}
          key={index}
          slot={slot}
          fullWidth={width > 1 * slot}
          images={images}
          addOn={addOn}
          type={isExpiredAddon(addOn.expirationDate) ? AddonsTypes.EXPIRED : AddonsTypes.ACTIVE}
          width={width}
          height={height}
          left={isMonthView ? positionLeft : positionLeftDayView}
          top={top}
        />

        {addOn.isAutoRenewable && !isExpiredDate(addOn.expirationDate) && (
          <TimelineAddOnCard
            onItemPress={onItemPress}
            key={index}
            slot={slot}
            fullWidth={widthRenewable > 1 * slot}
            images={images}
            addOn={{
              ...addOn,
              icon: 'icRefresh',
            }}
            type={AddonsTypes.RENEWABLE}
            width={widthRenewable}
            height={height}
            left={positionLeft + width}
            top={top}
          />
        )}
      </View>
    );
  });

  return <View style={styles.container}>{addOnsList}</View>;
}
TimelineAddOnsList.defaultProps = {
  theme: LightThemeColors,
  slot: Dimensions.get('window').width / 6,
  onItemPress: () => { },
};
TimelineAddOnsList.propTypes = {
  images: PropTypes.object,
  data: PropTypes.array,
  isMonthView: PropTypes.bool,
  slot: PropTypes.number,
  onItemPress: PropTypes.func,
  theme: PropTypes.shape({
    name: PropTypes.string,
    isDark: PropTypes.bool,
    colors: PropTypes.object,
  }),
  dates: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
};
export default withTheme(TimelineAddOnsList);
